import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { AdminHeader } from '../admin-header/admin-header';
import { AdminSidebar } from '../admin-sidebar/admin-sidebar';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-manual-stock-log',
  standalone: true,
  imports: [CommonModule, FormsModule, AdminHeader, AdminSidebar],
  templateUrl: './manual-stock-log.html',
  styleUrls: ['./manual-stock-log.css']
})
export class ManualStockLog implements OnInit {
  entries: any[] = [];
  search: string = '';
  startDate: string = '';
  endDate: string = '';
  baseUrl = 'https://logs.proofile.com.ng/api/manual-entries';

  constructor(private http: HttpClient) {}

  ngOnInit(): void {
    this.http.get<any[]>(this.baseUrl).subscribe(data => {
      this.entries = data;
    });
  }

  isInDateRange(dateStr: string): boolean {
    const date = new Date(dateStr);
    const from = this.startDate ? new Date(this.startDate) : null;
    const to = this.endDate ? new Date(this.endDate) : null;
    return (!from || date >= from) && (!to || date <= to);
  }

  filteredEntries() {
    return this.entries.filter(e =>
      e.stock_item_name.toLowerCase().includes(this.search.toLowerCase()) &&
      this.isInDateRange(e.created_at)
    );
  }

  exportToExcel() {
    const rows = this.filteredEntries().map(e => ({
      Product: e.stock_item_name,
      'Old Quantity': e.old_quantity,
      'New Quantity': e.new_quantity,
      'Added By': e.added_by,
      'Date': new Date(e.created_at).toLocaleString()
    }));

    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Manual Stock Entries');
    XLSX.writeFile(workbook, `manual_stock_entries_${Date.now()}.xlsx`);
  }
}
